
export default {
	actions: {
		async updateCurrentUserMarketingInfo(store, payload) {
			await window.request("PUT", "/v1/shared/marketing/contacts/current", payload);
		}
	}
};
